'use client'

import { Link } from '@/lib/i18n/settings'

import Button, { ButtonProps } from '@mui/material/Button'

export default function LinkButton({ children, href, ...rest }: ButtonProps & { href: string }) {
  const props = {
    ...rest,
    component: Link,
    href,
  }
  return <Button {...props}>{children}</Button>
}
